import {Button as ButtonBase, ButtonProps} from '@yandex-taxi/go-web-components'
import clsx from 'clsx'
import React from 'react'

import {css} from '../../theme/css'
import {theme} from '../../theme/theme'

export type Props = ButtonProps & {size?: 'XS' | 'S' | 'M' | 'L'; widthAuto?: boolean; target?: string; rel?: string}

const override = css``
const overrideMax = css``
const classes = {
  override,
  overrideMax,
  size_L: css`
    &.${override}.${overrideMax} {
      height: ${theme.spacing(7)}px;
    }
  `,
  size_M: css`
    &.${override}.${overrideMax} {
      height: ${theme.spacing(6)}px;
    }
  `,
  size_S: css``,
  size_XS: css`
    &.${override}.${overrideMax} {
      height: ${theme.spacing(4)}px;
      padding: ${theme.spacing(1, 2)};
    }
  `,
  widthAuto: css`
    width: auto !important;
  `,
}

/** @deprecated use `import {Button} from '@yandex-delivery/blocks` */
const Button = React.forwardRef<any, Props>(
  ({children, size = 'S', widthAuto, className, classes: initialClasses, ...props}, ref) => {
    const resultedClasses = initialClasses
      ? {...initialClasses, root: clsx(classes[`size_${size}`], initialClasses.root)}
      : {root: classes[`size_${size}`]}

    return (
      <ButtonBase
        {...props}
        ref={ref}
        classes={resultedClasses}
        className={clsx(classes.override, classes.overrideMax, widthAuto && classes.widthAuto, className)}
      >
        {children}
      </ButtonBase>
    )
  },
)

export default Button
